import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-PrivateTemplate",
  "use": "icon-PrivateTemplate-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-PrivateTemplate\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /><path d=\"M12,12A5.75,5.75,0,1,0,6.25,6.25,5.76,5.76,0,0,0,12,12ZM9.74,13.64A7.47,7.47,0,0,0,2.14,21v.43c0,2.11,3.36,2.11,7.6,2.11h4.52c4.08,0,7.6,0,7.6-2.11V21a7.47,7.47,0,0,0-7.6-7.32Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol